import { createStore, combineReducers, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import { notifyMiddleware } from 'store/middlewares';
import reducers from 'reducers';
import types from 'actions/types';

const appReducers = combineReducers(reducers);
const combinedReducer = (state, action) => appReducers(action.type === types.LOG_OUT ? undefined : state, action);
const composeEnhancers =
  typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    : compose;
const store = createStore(combinedReducer, composeEnhancers(applyMiddleware(thunk, notifyMiddleware)));

export { store };
